<template>

    <m-edit1/>

    <m-single-product-201 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard309","relatedCourse":false,"galleryFullSlider":false,"productAuthor":false,"showSpecifiedFeature":"\u062a\u0627\u0631\u06cc\u062e \u0627\u0646\u0642\u0636\u0627","showVariationProductImage":false,"mapFeatureName":null,"variationProductComponent":"VariationProduct"},...{}}' :style='""' class="my-3 container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                </m-single-product-201>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct201 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct201'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct201,mDiv },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
